export enum TEST_NET_ID {
  BASE = 8453,
  SEPOLIA = 11155111,
}

export enum VaultOptions {
  APR = "APR",
  TVL = "TVL",
  REWARDS = "Rewards",
}

export enum Tab {
  OVERVIEW = "overview",
  REFERRAL = "referral",
  MP = "mpoint",
}

export enum TabMapping {
  VAULT = "common.vault",
  APR = "common.apr",
  TVL = "common.tvl",
  EARNINGS = "common.earnings",
}

export enum TimePeriod {
  WEEKLY = "dashboard.chart.weekly",
  MONTHLY = "dashboard.chart.monthly",
  YEARLY = "dashboard.chart.yearly",
}

export enum CommissionOptions {
  COMMISSIONS = "Commissions",
  REFERRALS = "Referrals",
}